import { useCallback, useState } from "react";
import { find, head } from "lodash";
import { Project } from "@radarly/models/project";

export default function useProject(
  project: Project["id"],
  projects: Project[]
) {
  const [prj, setProject] = useState(
    find(projects, { id: project }) || head(projects)
  );
  const _setProject = useCallback(
    (id: Project["id"]) => {
      const _findedProject = find(projects, { id });
      if (_findedProject) {
        setProject(_findedProject);
      }
    },
    [projects]
  );
  return { project: prj, setProject: _setProject };
}
